import { Instance, types } from 'mobx-state-tree';
import {
  AIRequestsStore,
  AlgoritmsDirectoryStore,
  AppealsStore,
  AreasStore,
  AutomationStore,
  AutomationSuperStore,
  CallCardStore,
  CatalogueStore,
  CommonStore,
  ConstantsStore,
  CreateRequestStore,
  CrystalsStore,
  DashboardStore,
  DocumentsFlowStore,
  FiasStore,
  GisStore,
  HouseChatsStore,
  HousesStore,
  ManagementAccountingStore,
  MessengerStore,
  MetersStore,
  MetricsStore,
  NewsFeedStore,
  OnboardingStore,
  PhoneDirectoriesStore,
  PreviewerStore,
  ProvidersStore,
  QrCodeAuthStore,
  ReportsStore,
  RequestsAutoParsingStore,
  RequestsStore,
  ScriptStore,
  TabsStore,
  TelephonyStore,
  TenantsStore,
  TicketsStore,
  UserStore,
  WeatherStore,
  WorkersStore,
} from './models';

export const RootStore = types.model({
  appeals: types.optional(AppealsStore, {}),
  areas: types.optional(AreasStore, {}),
  houses: types.optional(HousesStore, {}),
  houseChats: types.optional(HouseChatsStore, {}),
  fias: types.optional(FiasStore, {}),
  gis: types.optional(GisStore, {}),
  user: types.optional(UserStore, {}),
  constants: types.optional(ConstantsStore, {}),
  workers: types.optional(WorkersStore, {}),
  tenants: types.optional(TenantsStore, {}),
  requests: types.optional(RequestsStore, {}),
  tickets: types.optional(TicketsStore, {}),
  meters: types.optional(MetersStore, {}),
  metrics: types.optional(MetricsStore, {}),
  catalogue: types.optional(CatalogueStore, {}),
  createRequest: types.optional(CreateRequestStore, {}),
  common: types.optional(CommonStore, {}),
  news: types.optional(NewsFeedStore, {}),
  callCard: types.optional(CallCardStore, {}),
  telephony: types.optional(TelephonyStore, {}),
  autoParsingRequests: types.optional(RequestsAutoParsingStore, {}),
  providers: types.optional(ProvidersStore, {}),
  algoritmsDirectory: types.optional(AlgoritmsDirectoryStore, {}),
  phoneDirectories: types.optional(PhoneDirectoriesStore, {}),
  previewer: types.optional(PreviewerStore, {}),
  script: types.optional(ScriptStore, {}),
  reports: types.optional(ReportsStore, {}),
  automation: types.optional(AutomationStore, {}),
  automationSuper: types.optional(AutomationSuperStore, {}),
  tabs: types.optional(TabsStore, {}),
  documentsFlow: types.optional(DocumentsFlowStore, {}),
  weather: types.optional(WeatherStore, {}),
  managementAccounting: types.optional(ManagementAccountingStore, {}),
  messenger: types.optional(MessengerStore, {}),
  aiRequests: types.optional(AIRequestsStore, {}),
  qrCodeAuth: types.optional(QrCodeAuthStore, {}),
  crystals: types.optional(CrystalsStore, {}),
  onboardings: types.optional(OnboardingStore, {}),
  dashboard: types.optional(DashboardStore, {}),
});

export const store = RootStore.create({});

export interface IRootStore extends Instance<typeof RootStore> {}
